var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { laggy } from '@juvare/platform-sdk-react/ui/utils';
import useSWR from 'swr';
import { useAlertServiceClient } from './index';
export function useSearchAlertResponders(alertId, request) {
    const alertServiceClient = useAlertServiceClient();
    return useSWR(['/alert/responders', alertId, request], (_a) => __awaiter(this, [_a], void 0, function* ([, alertId, request]) {
        return alertServiceClient.searchAlertResponders(alertId, request);
    }), {
        use: [laggy],
        revalidateOnFocus: false,
    });
}
